import React from 'react';
import { LogoX, LogoFacebook, LogoLinkedin, LogoInstagram } from '@carbon/icons-react';
// @ts-ignore
import * as styles from './Footer2025.module.scss';

const SOCIAL_LINKS = [
  { href: 'https://x.com/QF', label: 'X', Icon: LogoX },
  { href: 'https://www.facebook.com/qatarfoundation', label: 'Facebook', Icon: LogoFacebook },
  { href: 'https://www.linkedin.com/company/qatarfoundation', label: 'LinkedIn', Icon: LogoLinkedin },
  { href: 'https://www.instagram.com/qatarfoundation', label: 'Instagram', Icon: LogoInstagram },
];

type Props = { isThemePage?: boolean };

export default function Footer2025({ isThemePage }: Props) {
  return (
    <footer id="footer-2025" className={`${styles.footer} ${isThemePage ? styles.footerThemesPage : ''}`} role="contentinfo">
      <div className={styles.footerInner}>
        <div className={styles.social}>
          {SOCIAL_LINKS.map(({ href, label, Icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
              aria-label={label}
            >
              <Icon size={24} className={styles.socialIcon} fill="currentColor" />
            </a>
          ))}
        </div>
        <a
          href="https://www.qf.org.qa"
          target="_blank"
          rel="noopener noreferrer"
          className={styles.orgLink}
        >
          qf.org.qa
        </a>
      </div>
    </footer>
  );
}
